//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

import myQuery from '../search-shared/components/Query.vue';
import TransitionNavigate from "../global/transitions/Navigate";
import myFilters from "../search-shared/components/Filters";
import myTags from "../search-shared/components/Tags";
import myResultCount from "../search-shared/components/ResultCount";
import myResults from "./components/Results";
import myLoadMore from "../search-shared/components/LoadMore";

export default {
  name: "SearchApp",
	components: {
		myQuery,
		myFilters,
		TransitionNavigate,
		myTags,
		myResults,
		myLoadMore,
		myResultCount
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters([
			"filters",
			"reloading",
			"currentPage"
		]),
		anySelectedFilters() {
			return this.filters.some(f => f.filters.some(_f => _f.selected));
		}
	},
	methods: {},
	mounted() {},
};
